import React from 'react';

import './SealSpinner.css';

const SealSpinner = () => (<div className="SealSpinner"> </div>);

export default SealSpinner;
